import { AavoMosaic } from "src/components/common/mosaic/AavoMosaic.tsx";
import i18n from "i18next";
import { useRefreshRef } from "src/utils/useRefreshRef.ts";
import { TasksView } from "src/components/views/tasks/TasksView.tsx";
import { useUserData } from "src/contexts/useUserDataContext.ts";

export const TasksAssignedToMePage = () => {
	const { appUserId } = useUserData();
	const incompleteTasksRefreshRef = useRefreshRef();
	const completedTasksRefreshRef = useRefreshRef();
	return (
		<AavoMosaic
			viewId={"9164D192592F6562"}
			layout={{
				type: "tab",
				items: [
					{
						type: "panel",
						title: i18n.t("incomplete"),
						content: (
							<TasksView
								refreshRef={incompleteTasksRefreshRef}
								onTaskCompleted={() => completedTasksRefreshRef.current?.refresh()}
								taskQueryParams={{
									states: ["RELEASED", "STARTED"],
									assignedToUserId: appUserId,
								}}
								showAssignedTo={false}
							/>
						),
					},
					{
						type: "panel",
						title: i18n.t("completed"),
						content: (
							<TasksView
								refreshRef={completedTasksRefreshRef}
								taskQueryParams={{
									states: ["COMPLETED"],
									assignedToUserId: appUserId,
								}}
								onTaskCompletionReverted={() =>
									incompleteTasksRefreshRef.current?.refresh()
								}
								showAssignedTo={false}
								showGanttButton={false}
							/>
						),
					},
				],
			}}
		/>
	);
};
